export default "__VITE_ASSET__D$v2T0Gs__"